<template>

</template>

<script>
    export default {
        props: {
            id: '',
        },
        data(){
            return {
                //prevRoute: null,
            }
        },
        methods:{

            zeigeVisitenkarte: function (slug) {
               // Vue.set(this.isVisitenkarte, 'id', id);
                //statistik
                axios.get('/statistik/firma/loadVisitencard/Views/' + slug).then('OK');

            },

        },
        /*
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from
            })
        },
         */
        mounted() {
            //console.log('das ist die Referer Route ',this.prevRoute.path);
            console.log('bin in visitenkarte laden',this.id)
            this.id = this.id;
           // console.log(this.id);
            this.zeigeVisitenkarte(this.id)
           // console.log('Component mounted .' + this.id)
        }
    }
</script>
